import React from "react";
import axios from 'axios';

class Configurator extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            stepData: props.defaultStepData,
            pendingRequests: 0,
            debounceTimeout: null,
            isLoading: false,
            cancelToken: null
        }

        this.updateStepData = this.updateStepData.bind(this);
        this.doRequest = this.doRequest.bind(this);
        this.cancelCurrentRequest = this.cancelCurrentRequest.bind(this);
    }

    componentDidMount() {
        this.doRequest();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.pendingRequests !== prevState.pendingRequests) {
            this.setState({
                isLoading: this.state.pendingRequests > 0
            })
        }
    }

    cancelCurrentRequest() {
        if (this.state.cancelToken !== null) {
            this.state.cancelToken.cancel();

            this.setState({
                pendingRequests: this.state.pendingRequests - 1
            });
        }
    }

    doRequest(params) {
        this.cancelCurrentRequest();

        let data = Object.assign({}, this.state.stepData);

        if (typeof params !== 'undefined') {
            data.params = params;
        }

        const cancelTokenSource = axios.CancelToken.source()
        this.setState({
            cancelTokenSource: cancelTokenSource
        });

        this.setState({
            pendingRequests: this.state.pendingRequests + 1
        });

        axios.put(this.props.updateUrl, data, {
            params: data.params,
            cancelToken: cancelTokenSource.token
        }).then((response) => {
            if (response.data.redirectUrl) {
                location.href = response.data.redirectUrl;
                return;
            }

            this.setState({
                stepData: response.data,
                cancelToken: null,
                pendingRequests: this.state.pendingRequests - 1
            });
        }).catch(() => {
            this.setState({
                pendingRequests: this.state.pendingRequests - 1
            });
        });
    }

    updateStepData(data, preventUpdate, debounced) {
        this.setState({
            stepData: data
        }, () => {
            if (preventUpdate) {
                return;
            }

            if (debounced) {
                if (this.state.debounceTimeout) {
                    clearTimeout(this.state.debounceTimeout);
                }

                this.setState({
                    debounceTimeout: setTimeout(() => {
                        this.doRequest();
                    }, 500)
                })

                return;
            }

            this.doRequest();
        });
    }

    render() {
        return this.props.children({
            stepData: this.state.stepData,
            setStepData: this.updateStepData,
            doRequest: this.doRequest,
            isLoading: this.state.isLoading
        });
    }

}

export default Configurator;
